enum SubdomainEnum {
  Boletos = 'boletos'
}

export default SubdomainEnum
